import type { ReactNode } from "react";
import { useT } from "../../i18n";

/** Centered card layout shared by every pre-login page. */
export function AuthLayout({ title, subtitle, children }: { title: string; subtitle?: string; children: ReactNode }) {
  const t = useT();
  return (
    <div className="bg-grad-sage grid min-h-screen place-items-center p-4">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex items-center justify-center gap-2 text-2xl font-extrabold text-brand-dark">
          <span aria-hidden className="bg-grad-hero grid h-9 w-9 place-items-center rounded-full text-base text-white shadow-md">✓</span>
          {t("app.name").toLowerCase()}
        </div>
        <div className="rounded-card border border-line bg-surface p-6 shadow-lg">
          <h1 className="text-xl font-bold text-ink">{title}</h1>
          {subtitle && <p className="mb-4 mt-1 text-sm text-muted">{subtitle}</p>}
          {children}
        </div>
      </div>
    </div>
  );
}
